import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CloneMuxSpecificationRequest } from "./requests/CloneMuxSpecificationRequest";
import { CreateGpacMuxSpecificationRequest } from "./requests/CreateGpacMuxSpecificationRequest";
import { UpdateGpacMuxSpecificationRequest } from "./requests/UpdateGpacMuxSpecificationRequest";
import { UpdateManzanitaLanguageSpecificationMappingRequest } from "./requests/UpdateManzanitaLanguageSpecificationMappingRequest";
import { GetMuxSpecificationByIdResponse } from "./responses/GetMuxSpecificationByIdResponse";
import { GetMuxSpecificationListResponse } from "./responses/GetMuxSpecificationListResponse";
import { GetMuxSpecificationsLookupResponse } from "./responses/GetMuxSpecificationsLookupResponse";

export const useMuxSpecificationApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/mux-specifications`;

    const { httpGet, httpPost, httpPut } = useAuthorizedFetch();

    const getMuxSpecificationsLookup = async (): Promise<GetMuxSpecificationsLookupResponse> => {
        return httpGet<GetMuxSpecificationsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    const getMuxSpecificationById = async (id: string): Promise<GetMuxSpecificationByIdResponse> => {
        return httpGet<GetMuxSpecificationByIdResponse>(`${baseUrl}/get-by-id`, { id });
    };

    const getMuxSpecificationList = async (): Promise<GetMuxSpecificationListResponse> => {
        return httpGet<GetMuxSpecificationListResponse>(`${baseUrl}/list`);
    };

    const createGpacMuxSpecification = async (
        request: CreateGpacMuxSpecificationRequest
    ): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const updateGpacMuxSpecification = async (request: UpdateGpacMuxSpecificationRequest): Promise<void> => {
        return httpPut<void>(`${baseUrl}/update`, request);
    };

    const cloneMuxSpecification = async (request: CloneMuxSpecificationRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/clone`, request);
    };

    const updateManzanitaLanguageSpecificationMapping = async (
        request: UpdateManzanitaLanguageSpecificationMappingRequest
    ): Promise<void> => {
        return httpPut<void>(`${baseUrl}/language-specification/update-mapping`, request);
    };

    return {
        getMuxSpecificationsLookup,
        getMuxSpecificationList,
        getMuxSpecificationById,
        createGpacMuxSpecification,
        updateGpacMuxSpecification,
        cloneMuxSpecification,
        updateManzanitaLanguageSpecificationMapping
    };
};
